import { render, staticRenderFns } from "./order-confirmation.vue?vue&type=template&id=c99a04e0&scoped=true"
import script from "./order-confirmation.vue?vue&type=script&lang=ts"
export * from "./order-confirmation.vue?vue&type=script&lang=ts"
import style0 from "./order-confirmation.vue?vue&type=style&index=0&id=c99a04e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99a04e0",
  null
  
)

export default component.exports